var path = '/templates/projects.settings/initialization/index.html';
var html = "<div id=projectSettingsBase><h1 class=config-title translate=projectsSettings.initialization.index.info_of_initial_settings_moving translate-value-link=\"<a href='{{ appUrl }}/site/{{ project.apikey }}/settings/setup' target='_blank'>{{ 'projectsSettings.initialization.index.new_dashboard_name' | translate }}</a>\"></h1></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/index.html
// module id = 1540
// module chunks = 0